exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "\n.cellDateType[data-v-3fac1fb2]{\n    text-align:center;\n}\n", ""]);

// exports
